import React from "react";
import Table from "../../../components/UI/Table/Table";
import { CORPORATE_MASTER_COLUMNS } from "./constants.js";

const CorporateMasterTable = ({
  paginatedResponse,
  loading,
  pageSize,
  pageNumber,
  onPageChange,
  onPageSizeChange,
  sorted,
  onSortedChange
}) => {

  const data = paginatedResponse?.content || [];
  const pagination = paginatedResponse?.pageable || {};
  const totalPages = paginatedResponse?.totalPages || 0;

  return (
    <Table
      data={data}
      columns={CORPORATE_MASTER_COLUMNS}
      defaultSorted={[
        { id: "createdAt", desc: true }
      ]}
      sorted={Array.isArray(sorted) ? sorted : [sorted].filter(Boolean)}
      onSortedChange={onSortedChange}
      noDataText="No Data found"
      pages={totalPages}
      showPagination={pagination?.paged}
      showPaginationBottom
      manual
      loading={loading}
      onPageSizeChange={onPageSizeChange}
      onPageChange={onPageChange}
      pageSize={pageSize}
      page={pageNumber}
    />
  );
};

export default CorporateMasterTable;